import { GetPartnerWorkerResponse } from 'partner/shared/services/partner-worker-service.types';
import { Box, Chip, styled } from '@mui/material';
import { IconWarning } from '../../../../../assets/img';
import { StyledIcon } from '../../../../../shared/components/common/certificate-modal-styled-components';

export const PartnerWorkerDetailAccreditations = ({
  accreditations,
}: {
  accreditations: GetPartnerWorkerResponse['accreditations'];
}) => {
  return (
    <>
      <BoxStyled>
        {accreditations.map((acc) => (
          <AccreditationChip
            key={acc.id}
            label={acc.name}
            onClick={() => {
              if (acc.fileUrl) {
                window.open(acc.fileUrl, '_blank');
              }
            }}
            icon={!acc.fileUrl ? <StyledIcon as={IconWarning} /> : undefined}
            title={!acc.fileUrl ? 'Er is geen bestand geüpload voor dit certificaat' : undefined}
          />
        ))}
      </BoxStyled>
    </>
  );
};

const AccreditationChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.lwPrimaryAccentLight[5],
}));
const BoxStyled = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: '8px',
}));
